import { memo, SetStateAction, Dispatch } from 'react'
import * as L from 'leaflet'
import { Circle, Tooltip } from 'react-leaflet'
import { LatLngTuple } from 'leaflet'
import RedIcon from '../../../assets/images/point-icon-red.png'
import GreenIcon from '../../../assets/images/point-icon-green.png'
import { ICustomPoint } from '../../../types/emitter.type'
import Heatmap from '../Heatmap'
import HeatmapSettingsModal from '../map-entity/HeatmapSettingsModal'
import { IHeatmapRequest } from '../../../../shared/types/api/heatmap.type'
import DraggableMarker from '../DraggableMarker'
import { deepMerge } from '../../../utils/functions'
import { RecursivePartial } from '../../../../shared/types'

interface IProps {
  point: ICustomPoint
  onSelect: (id: string) => void
  setPoints: Dispatch<SetStateAction<ICustomPoint[]>>
}

/*
 * FIXME: When you generate a heatmap and then move the point,
 * the heatmap doesn't move.
 */
const CustomPoint: React.FC<IProps> = ({ point, setPoints, onSelect }) => {
  const LeafIcon = L.Icon.extend({
    options: {
      iconUrl: point.selected ? GreenIcon : RedIcon,
      iconSize: [30, 30],
    },
  })

  const blueIcon = new LeafIcon()

  const handleMarkerClick = () => {
    onSelect(point.id)
  }

  const handleUpdateParams = (updatedParams: IHeatmapRequest) => {
    setPoints((prev) => prev.map((elem) => (elem.id === point.id ? { ...elem, heatmapParams: updatedParams } : elem)))
  }

  const position: LatLngTuple = [point.latitude, point.longitude]

  if (!point) return null

  const updatePoint = (attrs: RecursivePartial<ICustomPoint>) => {
    setPoints((prev) => prev.map((elem) => (elem.id === point.id ? deepMerge(elem, attrs) : elem)))
  }
  const handlePositionChange = (latlng: { lat: number; lng: number }) => {
    const { lat, lng } = latlng
    updatePoint({
      latitude: lat,
      longitude: lng,
      heatmap: null,
      showHeatmap: false,
      heatmapParams: {
        transmitter: {
          lat: lat,
          lon: lng,
        },
      },
    })
  }

  return (
    <>
      <DraggableMarker
        draggable={true}
        center={position}
        handleClick={handleMarkerClick}
        handlePositionChange={handlePositionChange}
        setDragging={() => {}}
        icon={blueIcon}
      >
        <Tooltip opacity={0.6}>
          {position[0]}, {position[1]}
        </Tooltip>
      </DraggableMarker>

      {point.showRadius && position && <Circle center={position} radius={point.radius * 1000} />}

      {point.showHeatmap && <Heatmap heatmap={point.heatmap} />}

      <HeatmapSettingsModal
        isOpen={!!point.showHeatmapSettings}
        onClose={() => updatePoint({ showHeatmapSettings: false })}
        onUpdate={handleUpdateParams}
        initialValues={point.heatmapParams}
      />
    </>
  )
}

export default memo(CustomPoint)
